import { z } from "zod";

export const Rating_Schema = z.number().min(0, { message: "Rating must be >= 0." }).max(5, { message: "Rating must be <= 5." });
